import React from 'react'

import { CSSObject } from '@emotion/react'

import { Box, DisplayPosition, Image, withCitrusTheme } from '@gousto-internal/citrus-react'

import menuPng from '../../../assets/EffortlessHomeCookingSection/menu.png'
import menuWebp from '../../../assets/EffortlessHomeCookingSection/menu.webp'

const Container = withCitrusTheme(Box, (theme) => ({
  ...(theme.responsiveStyle(
    ['60%', '63%', '69%', 'calc(50% - 90px)', 'calc(50% - 170px)'],
    ['left'],
  ) as CSSObject),
}))

export function MenuOverlay() {
  return (
    <Container
      bottom="0"
      height={['480px', null, null, '430px']}
      position={DisplayPosition.Absolute}
    >
      <Image src={menuPng} srcSet={menuWebp} alt="" width="unset" />
    </Container>
  )
}
